import axios from 'axios';
import params from 'configs/params';
import { TOKEN } from 'configs/constants';

const apiUrl = params.apiUrl;
const xFunctionsKey = params.xFunctionsKey;
const ocpApimSubscriptionKey = params.ocpApimSubscriptionKey;

export function attemptStartRental(data) {
  let url = `${apiUrl}/start-rental`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptEndRental(data) {
  let url = `${apiUrl}/end-rental`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptLinkQuickshop(data) {
  let url = `${apiUrl}/link-quickshop`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptGetMeasurementData(data) {
  return axios.request({
    url: `${apiUrl}/pos-session/${data}/measurment-data`,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptStartPOSSession(data) {
  let url = `${apiUrl}/start-pos-session`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptStopPOSSession(data) {
  let url = `${apiUrl}/stop-pos-session`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptGetBookingCart(data) {
  let url = `${apiUrl}/users/${data}/cart`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptGetReceiptData(data) {
  let url = `${apiUrl}/receipt/${data}`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptAddProductToCart(params) {
  let url = `${apiUrl}/users/${params.userId}/cart`;

  const data = {
    webShopID: params.webShopID,
    webShopName: params.webShopName,
    product: params.product,
  };

  return axios.request({
    url,
    method: 'PATCH',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptCheckSwishPaymentStatus(data) {
  let url = `${apiUrl}/possessions/${data}/payment-status`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptPayPOSSession(data) {
  const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);

  let url = `${apiUrl}/pay-pos-session`;

  return axios.request({
    url,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
    data,
  });
}

export function attemptGetTopMeasurementData(data) {
  const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);

  let url = `${apiUrl}/pos-session/${data}/top-measurment-data`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptGetQuickshop(data) {
  const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);

  let url = `${apiUrl}/quickshop/${data}`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptUpdateQuickshop(data) {
  const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);

  let url = `${apiUrl}/update-pos-session`;

  return axios.request({
    url,
    method: 'PATCH',
    withCredentials: false,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}

export function attemptGetPOSSession(data) {
  const token = localStorage.getItem(TOKEN) || sessionStorage.getItem(TOKEN);

  let url = `${apiUrl}/pos-session/${data}`;

  return axios.request({
    url,
    method: 'GET',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
      'x-functions-key': xFunctionsKey,
      'Ocp-Apim-Subscription-Key': ocpApimSubscriptionKey,
    },
  });
}
